var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EmailModal.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-20ef7fb8\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EmailModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/keystone/components/Modals/EmailModal.vue
// module id = 607
// module chunks = 1